import React from 'react';
import './SocialNetworks.css';
import { ReactComponent as InstagramIcon } from '../../../../assets/svg/social/Instagram.svg';
import { ReactComponent as FacebookIcon } from '../../../../assets/svg/social/Facebook.svg';

export default function SocialNetworks() {
    return (
        <div className={'social-networks'}>
            <a target="blank" href={'https://www.instagram.com/musical_shepherds_mini_aussies/'}>
                <InstagramIcon className={'social-networks__icon'} />
            </a>
            <a target="blank" href={'https://www.facebook.com/profile.php?id=100084704414201'}>
                <FacebookIcon className={'social-networks__icon'} />
            </a>
        </div>
    );
}
